import { ClientAdProductType } from '@zg-rentals/ts-rental-manager-api-client';

export const PACKAGE_TIER_ORDER: Partial<Record<ClientAdProductType, number>> = {
  [ClientAdProductType.BASE_PACKAGE]: 1,
  [ClientAdProductType.ENHANCED_PACKAGE]: 2,
  [ClientAdProductType.PREMIUM_PACKAGE]: 3,
  [ClientAdProductType.PREMIUM_PLUS_PACKAGE]: 4,
  [ClientAdProductType.SIGNATURE_PACKAGE]: 5,
};

export type AmenityFeature = {
  label: string;
  field: keyof {
    is3dTourEnabled: boolean;
    inUnitLaundry: boolean;
    fitnessCenter: boolean;
    swimmingPool: boolean;
    petFriendly: boolean;
  };
};

export const AMENITY_FEATURES: Array<AmenityFeature> = [
  { label: '3D tour', field: 'is3dTourEnabled' },
  { label: 'In-unit laundry', field: 'inUnitLaundry' },
  { label: 'Fitness center', field: 'fitnessCenter' },
  { label: 'Swimming pool', field: 'swimmingPool' },
  { label: 'Pet friendly', field: 'petFriendly' },
];
